"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _emotionTheming = require("emotion-theming");

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _theme = require("@tablekit/theme");

var _getButtonProps = _interopRequireDefault(require("./utils/getButtonProps"));

var _getButtonStyles = require("./styled/getButtonStyles");

var _ButtonContent = _interopRequireDefault(require("./styled/ButtonContent"));

var _ButtonWrapper = _interopRequireDefault(require("./styled/ButtonWrapper"));

var _LoadingSpinner = _interopRequireDefault(require("./styled/LoadingSpinner"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function renderIcon(icon, props) {
  if ((0, _isFunction["default"])(icon)) {
    return icon(props);
  }

  var size = props.size || _theme.SIZES.REGULAR; // $FlowFixMe handled with isFunction

  return /*#__PURE__*/(0, _react.cloneElement)(icon, {
    size: size
  });
}

var ButtonContainer = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var href = _ref.href,
      target = _ref.target,
      component = _ref.component,
      isDisabled = _ref.isDisabled,
      otherProps = _objectWithoutProperties(_ref, ["href", "target", "component", "isDisabled"]);

  var ResolvedComponent = _getButtonStyles.StyledButton;
  var additionalProps = {};

  if (component) {
    ResolvedComponent = _getButtonStyles.StyledButton.withComponent(component, {
      target: "e1jpzqr50",
      label: "ButtonContainer"
    });
  } else if (href) {
    if (isDisabled) {
      ResolvedComponent = _getButtonStyles.StyledButton;
    } else {
      ResolvedComponent = _getButtonStyles.StyledLink;
      additionalProps = {
        href: href,
        target: target
      };
    }
  }

  return (0, _core.jsx)(ResolvedComponent, _extends({
    ref: ref,
    disabled: isDisabled
  }, additionalProps, otherProps));
});
ButtonContainer.displayName = 'ButtonContainer';

var Button = function Button(_ref2) {
  var innerRef = _ref2.innerRef,
      props = _objectWithoutProperties(_ref2, ["innerRef"]);

  var children = props.children,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
      shouldFitContainer = props.shouldFitContainer,
      theme = props.theme,
      tabIndex = props.tabIndex,
      _onClick = props.onClick,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      href = props.href,
      target = props.target;
  var iconBefore = props.iconBefore,
      iconAfter = props.iconAfter;
  var buttonProps = (0, _getButtonProps["default"])(props);

  if (theme && theme.isRtl) {
    var tempIcon = iconBefore;
    iconBefore = iconAfter;
    iconAfter = tempIcon;
  }

  var iconIsOnlyChild = !!(iconBefore && !iconAfter && !children || iconAfter && !iconBefore && !children);
  return (0, _core.jsx)(ButtonContainer, _extends({
    ref: innerRef,
    isOnlyChild: iconIsOnlyChild,
    tabIndex: tabIndex
  }, buttonProps, {
    type: type,
    href: href,
    target: target,
    onClick: function onClick(e) {
      if (isDisabled || isLoading) {
        e.stopPropagation();
      }

      if (_onClick) _onClick(e);
    }
  }), (0, _core.jsx)(_ButtonWrapper["default"], {
    fit: !!shouldFitContainer
  }, isLoading ? (0, _core.jsx)(_LoadingSpinner["default"], {
    size: buttonProps.size,
    appearance: buttonProps.appearance,
    isDisabled: buttonProps.isDisabled
  }) : null, iconBefore && (0, _core.jsx)(_getButtonStyles.IconWrapper, {
    isLoading: isLoading
  }, renderIcon(iconBefore, buttonProps)), children ? (0, _core.jsx)(_ButtonContent["default"], {
    hasIconAfter: !!iconAfter,
    hasIconBefore: !!iconBefore,
    isLoading: !!isLoading,
    followsIcon: !!iconBefore,
    size: buttonProps.size
  }, children) : null, iconAfter && (0, _core.jsx)(_getButtonStyles.IconWrapper, {
    isLoading: isLoading
  }, renderIcon(iconAfter, buttonProps))));
};

Button.displayName = 'Button';
/** @component */

var _default = (0, _emotionTheming.withTheme)( /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return (0, _core.jsx)(Button, _extends({
    innerRef: ref
  }, props));
}));

exports["default"] = _default;